<script lang="ts">
  import Sprite from "./sprite.svelte";
  import { createEventDispatcher } from "svelte";

  export let collapsedTitle = "";
  export let expandedTitle = "";
  export let style: string | null = null;
  export let expanded = false;

  const dispatch = createEventDispatcher();

  function toggle() {
    dispatch("toggle", !expanded);
  }

  $: icon = expanded ? "icon-fullscreen-close" : "icon-fullscreen-open";
  $: label = expanded ? "Show contents" : "Hide contents";
  $: title = expanded ? expandedTitle : collapsedTitle;
</script>

<div class="Drawer" class:expanded {style}>
  <header>
    <h1 class="Title">
      <button
        class="Toggle"
        aria-label={label}
        on:click|preventDefault={toggle}
        aria-expanded={expanded}
      >
        {title}
        <Sprite {icon} />
      </button>
    </h1>
  </header>

  <div class="Content">
    {#if expanded}
      <slot />
    {/if}
  </div>
</div>

<style>
  .Drawer {
    background: white;
    border-top-left-radius: var(--border-radius-large);
    border-top-right-radius: var(--border-radius-large);
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    height: var(--appbar-height);
    left: 10px;
    overflow: hidden;
    position: fixed;
    right: 10px;
    top: calc(
      100% - (var(--nav-height, 0px) + var(--appbar-height, 0px)) - var(--drawer-offset, 0px)
    );
    z-index: var(--z-drawer);
  }

  .Drawer.expanded {
    border-radius: 0;
    top: 0;
    height: calc(100% - var(--nav-height));
    left: 0;
    right: 0;
    transition:
      0.3s top,
      0.3s border-radius;
  }

  header {
    align-items: center;
    display: flex;
    min-height: var(--appbar-height);
    justify-content: center;
    width: 100%;
    flex: 0 0;
  }

  .Content {
    background: var(--background-color, #111111);
    flex: 1 1;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .Title {
    margin: 0;
    padding: 16px var(--outer-padding);
    position: relative;
    text-transform: uppercase;
    top: 1px; /* align with apex of arrow */
    width: 100%;
  }

  .Toggle {
    color: currentColor;
    padding: 0;
    display: flex;
    flex: 0 1;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.12em;
    line-height: 1;
    width: 100%;
    align-items: center;
  }
</style>
